import React from 'react';
import { useSelector } from 'react-redux';
import { getMediaPack } from '@src/containers/ProfileVendor/selectors/getMediaPack';
import { useActions } from '@src/containers/ProfileVendor/hooks';
import { useFetchAlbumMedia } from '@src/containers/Album/hooks/useFetchAlbumMedia';
import { useFetchSetCover } from '@src/containers/ProfileVendor/hooks/useFetchSetCover';
import { getVenueCoverSources } from '@src/containers/ProfileVenue/selectors/getVenueCoverSources';
import { getAlbumMedia } from '@src/containers/Album/selectors/getAlbumMedia';
import { getProfileMedia } from '@src/containers/ProfileVenue/selectors/getProfileMedia';
import { useLoadMediaWatcher } from '@src/containers/ProfileVenue/hooks';
import { getAlbumMeta } from '@src/containers/Album/selectors/getAlbumMeta';

import ModalPhotoCover from '..';

const per_page = 50;

const ModalPhotoCoverCVenue = () => {
	const mediaPack = useSelector(getMediaPack);
	const albums = useSelector(getVenueCoverSources);
	const medias = useSelector(getAlbumMedia);
	const { room } = useSelector(getProfileMedia);

	const albumMeta = useSelector(getAlbumMeta);
	const [morePage, setMorePage] = React.useState(1);
	const { fetchAlbumMedia, fetchAlbumMediaMore } = useFetchAlbumMedia();
	const { fetchSetCover } = useFetchSetCover();

	const { loadMediaWatcher: refetchData } = useLoadMediaWatcher();

	const [activeAlbum, setActiveAlbum] = React.useState(null);
	const [isLoading, setIsLoading] = React.useState(false);

	React.useEffect(() => {
		if (activeAlbum) {
			const isAlbum = typeof activeAlbum.value === 'number';
			if (isAlbum) {
				setIsLoading(true);
				fetchAlbumMedia({
					albumId: activeAlbum.value,
					per_page,
					type: 'image',
					order: 'position',
				}).finally(() => {
					setIsLoading(false);
				});
			}
		}
	}, [activeAlbum, fetchAlbumMedia]);

	const handleMoreClick = React.useCallback(() => {
		if (activeAlbum) {
			setIsLoading(true);
			fetchAlbumMediaMore({
				albumId: activeAlbum.value,
				page: morePage + 1,
				per_page,
				type: 'image',
				order: 'position',
			}).finally(() => {
				setMorePage(morePage + 1);
				setIsLoading(false);
			});
		}
	}, [activeAlbum, morePage, fetchAlbumMediaMore]);

	const options = React.useMemo(() => {
		const result = albums.map((a) => {
			return {
				label: a.title,
				value: a.id,
			};
		});
		if (!activeAlbum) {
			setActiveAlbum(result[0]);
		}
		return result;
	}, [albums, activeAlbum]);

	const images = React.useMemo(() => {
		const target = activeAlbum?.value;
		if (typeof target === 'number') {
			return medias.map((m) => {
				return {
					src: m.original_url?.split('=')[0],
					mediaId: m.id,
					forceVisibility: true,
				};
			});
		}
		if (typeof target === 'string' && target.includes('room_')) {
			const prop = target.split('_')[1];
			const m = room ? room[prop] : [];
			return (m || []).map((i) => {
				if (typeof i === 'number') {
					return {
						src: i,
						mediaId: i,
						forceVisibility: true,
					};
				}
				return {
					src: i.url,
					mediaId: i.id,
					forceVisibility: true,
				};
			});
		}
		return [];
	}, [medias, room, activeAlbum]);

	const { setMediaPack } = useActions();

	const handleChange = React.useCallback((data) => {
		setActiveAlbum(data);
	}, []);

	const handleClose = React.useCallback(() => {
		setMediaPack();
	}, [setMediaPack]);

	const onClickImg = React.useCallback(
		async (img) => {
			const newPack = [...mediaPack.data];

			newPack.splice(mediaPack.index, 1, {
				mediaId: img.mediaId,
				align: 'center',
			});

			setIsLoading(true);

			await fetchSetCover({
				data: { data: newPack, specId: mediaPack.specId },
			});
			await refetchData();
			setIsLoading(false);
			handleClose();
		},
		[mediaPack, fetchSetCover, refetchData, handleClose],
	);

	const modalProps = React.useMemo(() => {
		return {
			isOpen: true,
			status: isLoading ? 'loading' : undefined,
			onClose: handleClose,
		};
	}, [handleClose, isLoading]);

	if (!mediaPack) return null;
	const isMoreAvail = albumMeta?.pages_count > morePage;

	return (
		<ModalPhotoCover
			value={activeAlbum}
			modalProps={modalProps}
			options={options}
			placeholder={t('Альбом')}
			onChange={handleChange}
			onClickImg={onClickImg}
			onClickLoadmore={isMoreAvail ? handleMoreClick : undefined}
			imgs={images}
			title={t('Выберите фотографию для обложки')}
		/>
	);
};

export default ModalPhotoCoverCVenue;
